import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 2000; // 2 seconds for a slow, smooth glide
    let start: number | null = null;
    const step = (timestamp: number) => {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const percentage = Math.min(progress / duration, 1);
      // Easing function: easeInOutCubic
      const easing = percentage < 0.5 ? 4 * percentage * percentage * percentage : 1 - Math.pow(-2 * percentage + 2, 3) / 2;
      window.scrollTo(0, startPosition + distance * easing);
      if (progress < duration) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  };
  return <section className="md:pt-0 pb-0 bg-[#fdfaf6] overflow-hidden pt-0" data-id="element-94">
      <div className="grid md:grid-cols-2 gap-0 items-stretch" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="order-2 md:order-1 px-6 md:pl-16 md:pr-12 pt-0 md:py-20 flex flex-col justify-center pb-[0px]" data-id="element-96">
          <button onClick={scrollToPricing} className="w-full md:w-auto hover:bg-[#c4a030] text-white font-bold py-5 px-10 rounded-xl text-xl shadow-xl transition-all transform hover:scale-105 active:scale-95 mb-8 md:order-last md:mb-0 bg-[#09A009] pt-[10px] pb-[10px] pl-[40px] pr-[40px] mt-0" data-id="element-97">
            QUIERO ACCEDER AHORA
          </button>
          <h1 className="text-4xl md:text-6xl font-bold text-[#5d4037] leading-tight mb-6" data-id="element-98">
            Aprendé Cerrajería Desde Cero y Sumá una Habilidad con Salida
            Laboral
          </h1>
          <p className="text-lg md:text-xl text-[#8b6b61] mb-8 leading-relaxed" data-id="element-99">
            Una guía práctica para aprender cerrajería del hogar, automotriz y
            sumar conocimientos útiles para empezar desde casa.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="order-1 md:order-2 relative flex items-start h-full pt-12 md:pt-20" data-id="element-100">
          <img src="https://cdn.magicpatterns.com/uploads/mvAayfcb3KVNN6o2cL2Uzd/ChatGPT_Image_28_jun_2026,_16_08_02.webp" alt="Libro de Cerrajería" className="w-full h-auto block" data-id="element-101" />
        </motion.div>
      </div>
    </section>;
}